import React from 'react';
import { Box, Flex, Button } from 'rebass';
import { useColors } from '@osmosis/react-ui/hooks/useColors';
import { Plan, PlansPage } from '../../types/plans';
import { PlanCard } from './PlanCard';
import { ColorProps } from '@osmosis/shared/styles';
import { FormattedMessage } from 'react-intl';
import { P } from '@osmosis/react-ui/components/Text';

/**
 *Plans Selection.
 */
const PlansSelection = (props: { plansPage: PlansPage; plans: Plan[] }) => {
  const {
    plansPage: { deal, trialCTAEnabled = false },
    plans = [],
  } = props;

  return (
    <Box
      sx={{
        width: '100%',
      }}
    >
      <Box
        display="flex"
        id="outer-wrapper"
        sx={{
          flexDirection: 'column',
        }}
      >
        <Flex
          sx={{
            flexDirection: ['column', 'column', 'row'],
          }}
          id="inner-wrapper"
          data-testid="plans"
          maxWidth={870}
          width="100%"
          margin="auto"
          alignItems="center"
        >
          {plans
            ?.sort((a, b) => b.currency.unitAmount - a.currency.unitAmount)
            .map((plan: Plan, index: number) => (
              <Flex
                key={plan.hash}
                display="flex"
                margin="20px"
                width="100%"
                sx={{
                  maxWidth: ['500px', '500px', '250px'],

                  mb: ['30px', '30px', '0px'],
                  transition: 'all 0.2s ease-in-out',
                  position: 'relative',
                }}
              >
                <PlanCard index={index} plan={plan} deal={deal} />
              </Flex>
            ))}
        </Flex>
        {trialCTAEnabled && <FreeTrial />}
      </Box>
    </Box>
  );
};

const Divider = ({ colors }: { colors: ColorProps }) => (
  <Box
    data-testid="divider"
    textAlign="center"
    marginY="auto"
    flexBasis="45%"
    sx={{
      backgroundColor: colors.gray10,
    }}
    height={2}
  />
);

const FreeTrial = (): JSX.Element => {
  const colors = useColors();

  return (
    <Flex
      sx={{ width: ['500px', '500px', '800px'] }}
      alignItems="center"
      flexDirection="column"
    >
      {/* or */}
      <Flex width="100%" paddingTop="20px" paddingBottom="20px">
        <Divider colors={colors} />
        <P fontSize={2} color="text" fontWeight="700" opacity={0.4} m="0 20px">
          <FormattedMessage id="plans.cta.or" defaultMessage="OR" />
        </P>
        <Divider colors={colors} />
      </Flex>
      {/* text */}
      <P
        fontSize={2}
        color="text"
        fontWeight="heading"
        paddingTop="20px"
        paddingBottom="20px"
      >
        <FormattedMessage
          id="plans.cta.offer"
          defaultMessage="Try it for free for 1 week. No credit card required."
        />
      </P>
      {/* button */}
      <Button
        data-testid="button2"
        color="inherit"
        display="flex"
        alignItems="center"
        sx={{
          borderColor: 'black',
          opacity: '0.4',
          borderWidth: '1px',
          borderStyle: 'solid',
          borderRadius: '10rem',
          boxShadow: '0 0 0 1px #c9c9c9',
          height: '2.5em',
          background: 'inherit',
          willChange: 'transform',
          ':hover': {
            background: colors.gray10,
          },
        }}
        width="fit-content"
        paddingTop="20px"
        paddingBottom="20px"
        as="a"
        href="/login?type=create"
      >
        <FormattedMessage
          id="plans.cta.button"
          defaultMessage="Start free trial"
        />
      </Button>
    </Flex>
  );
};

export default PlansSelection;
